// Icons for Benefits (imported SVGs)
import CostEffectiveness from './assets/images/cost-effectiveness.svg';
import CustomerService from './assets/images/customer-service.svg';
import Locate from './assets/images/locate-fixed.svg';
import HandShake from './assets/images/hand-shake.svg';


export const benefits = [
  {
    icon: CostEffectiveness,
    name: 'Cost-Effectiveness (End-to-End Delivery)',
    description:
      'One team manages and executes your project - from earthworks through to final completion - reducing unnecessary costs, risk, simplifying communication, and improving outcomes.',
  },
  {
    icon: Locate,
    name: 'Local Developer for Local Conditions',
    description:
      'We understand local ground conditions, weather challenges, council processes, and New Zealand Building Code requirements — and we build accordingly.',
  },
  {
    icon: CustomerService,
    name: 'Condensed Timeline (In-House Capability)',
    description:
      'With our own architect, project manager, builders, and operators, we control timelines, quality and cost — not third parties.',
  },
  {
    icon: HandShake,
    name: 'Straightforward Communication',
    description:
      'We provide clear timelines, honest updates, and practical advice — no surprises, no unnecessary jargon.',
  },
];
